import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import PhotoGallery from './pages/PhotoGallery';
import PublicShare from './components/PublicShare';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

function AppContent() {
  const location = useLocation();
  const isSharePage = location.pathname.startsWith('/share/');

  // Для публичных ссылок не используем Layout и авторизацию
  if (isSharePage) {
    return (
      <Routes>
        <Route path="/share/:token" element={<PublicShare />} />
      </Routes>
    );
  }

  return (
    <ProtectedRoute>
      <Layout>
        <Routes>
          <Route path="/" element={<PhotoGallery />} />
        </Routes>
      </Layout>
    </ProtectedRoute>
  );
}

export default App;